import { forwardRef } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { CustomButtonBase } from 'src/components/CustomButtonBase';
import { TruncatedTypography } from 'src/components/TruncatedTypography';

import useStyles from './useStyles';

export const ButtonGenerationMode = forwardRef(
  ({ className, classes, title, description, onClick, selected, disabled }, ref) => {
    const styles = useStyles({ classes });

    return (
      <CustomButtonBase
        className={cx(styles.root, className, {
          [styles.selected]: selected,
        })}
        onClick={onClick}
        disabled={disabled}
        data-testid="ButtonGenerationMode"
        ref={ref}
      >
        <div className={styles.titleWrapper}>
          <TruncatedTypography className={styles.title}>{title}</TruncatedTypography>
        </div>
        {description && (
          <TruncatedTypography className={styles.description}>{description}</TruncatedTypography>
        )}
      </CustomButtonBase>
    );
  }
);

ButtonGenerationMode.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({}),
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
};
ButtonGenerationMode.defaultProps = {
  className: null,
  classes: null,
  description: '',
  selected: false,
  disabled: false,
};
